import React, {
    createContext,
    memo,
    useContext,
    useMemo,
} from "react";
import PropTypes from "prop-types";

const AccountContext = createContext("global.account");

export const AccountContextProvider = memo(
    ({ account, children }) => {
        return (
            <AccountContext.Provider value={account}>
                {children}
            </AccountContext.Provider>
        );
    }
);

AccountContextProvider.defaultProps = {
    children: null,
    account: undefined,
};

AccountContextProvider.propTypes = {
    account: PropTypes.string,
    children: PropTypes.node,
};

AccountContextProvider.displayName = "AccountContextProvider";

export const useAccountContext = () => {
    const account = useContext(AccountContext);
    return useMemo(() => ({ account }), [account]);
};

export default AccountContextProvider;
